import * as Connector from 'shared/connectors/investorsConnector';
import { INVESTOR } from 'store/types';

const init = () => ({
  type: INVESTOR.GET_ARCHIVED_INVESTOR_INIT,
});

export const success = data => ({
  type: INVESTOR.GET_ARCHIVED_INVESTOR_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: INVESTOR.GET_ARCHIVED_INVESTOR_FAILURE,
});

const getArchivedInvestor = uuid => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getArchivedInvestor(uuid);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getArchivedInvestor;
